import * as React from "react";
import Select from "react-select";
import Axios from "axios";
import { getIdToken } from "firebase/auth";
import { useContext } from "react";
import { AuthContext } from "AuthContext";
import { FormControl, InputLabel } from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL;

const DivisionLkp = ({ onChange, divisionRef, isDisabled }) => {
    const { currentUser } = useContext(AuthContext);

    const [data, setData] = React.useState([]);
    const [selectedOption, setSelectedOption] = React.useState();

    React.useEffect(() => {
        fetchData();
    }, []);

    React.useEffect(() => {
        if (divisionRef && data.length > 0) {
            const option = findOptionByValue(divisionRef);
            if (option) setSelectedOption(option);
        }
    }, [divisionRef, data]);

    const fetchData = async () => {
        try {
            const idToken = await getIdToken(currentUser);

            const response = await Axios.get(`${API_URL}Division/GetDivisionList/`, {
                headers: { 'Authorization': `Bearer ${idToken}` }
            });

            const list = response.data.map(item => ({
                value: item.id,
                label: `${item.preFixChar}-${item.title}`,
            }));

            setData(list);
        } catch (error) {
            console.error(error);
        }
    }

    const selectedOptionHandler = (selectedValue) => {
        setSelectedOption(selectedValue);
        onChange(selectedValue);
    }

    const findOptionByValue = (value) => {
        return data.find(option => option.value === value);
    };

    return (
        <>
                <InputLabel id="division-label" style={{ paddingBottom: '10px' }}>Division</InputLabel>

                <Select
                    className="form-control"
                    value={selectedOption}
                    onChange={selectedOptionHandler}
                    options={data}
                    controlShouldRenderValue
                    isClearable
                    isDisabled={isDisabled}
                />
        </>
    )
}

export default DivisionLkp;
